import { React } from 'react'
import './PopUp.css'
import close from '../../assets/close.svg'
const PopUp = (props) => {
    const isFunction = (functionToCheck) => {
        return (
            functionToCheck &&
            {}.toString.call(functionToCheck) === '[object Function]'
        )
    }
    return (
        <div
            className="overlay"
            style={
                props.isToast
                    ? { background: 'none', top: props.top, right: props.right }
                    : null
            }
        >
            <div
                className="popup"
                style={
                    props.toastType === 'danger'
                        ? {
                              background: 'red',
                              color: '#fff',
                              fontWeight: 'bold',
                              width: props.width,
                              height: props.height,
                          }
                        : props.toastType === 'success'
                        ? {
                              background: 'green',
                              color: '#fff',
                              fontWeight: 'bold',
                              width: props.width,
                              height: props.height,
                          }
                        : props.toastType === 'validate'
                        ? {
                              backgroundColor: 'rgb(245 247 250)',
                              width: '35%',
                              margin: '150px auto',
                          }
                        : props.style
                }
            >
                <div className="content">{props.children}</div>
                {!props.isToast && !props.hideCloseButton ? (
                    <img
                        className="close"
                        style={{ background: props.closeButtonBackground }}
                        src={close}
                        onClick={() => {
                            props.setShowPopUp(false)
                            if (isFunction(props.callback)) props.callback(false)
                            if (props.callback2) props.callback2(true)
                        }}
                    />
                ) : null}
            </div>
        </div>
    )
}
export default PopUp
